import React, {FC, useState} from "react"

import {useTheme} from "@irati/ui/src/global/useTheme"
import authentication from "@irati/auth"
import intercom from "@irati/utils/intercom"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import BoldNumberSmallText from "../BoldNumberSmallText"
import EmptyWidget from "../EmptyWidget"
import RecognitionModal from "./RecognitionModal"

interface Props extends InjectIntl {}

const EmptyCelebrations: FC<Props> = ({formatMessage}) => {
  const theme = useTheme()
  const [show, setShow] = useState(false)
  const title = authentication.apps("recognition")
    ? "admin.components.dashboard.reporting.recognition.empty.noData.title"
    : "admin.components.dashboard.reporting.recognition.empty.turnedOff.title"
  const buttonText = authentication.apps("recognition")
    ? "admin.components.dashboard.reporting.recognition.empty.noData.button"
    : "admin.components.dashboard.reporting.recognition.empty.turnedOff.button"
  const handleClick = authentication.apps("recognition") ? () => setShow(true) : intercom.addCustomMessage("")

  return (
    <>
      <EmptyWidget title={title} buttonText={buttonText} onClick={handleClick} img="admin.components.dashboard.reporting.recognition.img">
        <BoldNumberSmallText
          boldValue={formatMessage({id: "admin.components.dashboard.reporting.recognition.empty.bold1"})}
          text="admin.components.dashboard.reporting.recognition.empty.text1"
          color={theme.colors.greys.white}
        />
        <BoldNumberSmallText
          boldValue={formatMessage({id: "admin.components.dashboard.reporting.recognition.empty.bold2"})}
          text="admin.components.dashboard.reporting.recognition.empty.text2"
          color={theme.colors.greys.white}
        />
      </EmptyWidget>
      <RecognitionModal show={show} onHide={() => setShow(false)} />
    </>
  )
}

export default injectIntl(EmptyCelebrations)
